import { render, staticRenderFns } from "./Checkboard.vue?vue&type=template&id=07c2e9c1&"
import script from "./Checkboard.vue?vue&type=script&lang=ts&"
export * from "./Checkboard.vue?vue&type=script&lang=ts&"
import style0 from "./Checkboard.vue?vue&type=style&index=0&id=07c2e9c1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports